Vue.component("salepage-body-show-component", require("./Index.vue").default);
Vue.component("salepage-body-sidebar-component", require("./Sidebar.vue").default);


Vue.component("salepage-body-grid-product-component", require("./product/Grid.vue").default);
Vue.component("salepage-body-classic-product-component", require("./product/Classic.vue").default);
Vue.component("salepage-body-modern-product-component", require("./product/Modern.vue").default);
Vue.component("salepage-body-detail-product-component", require("./product/Detail.vue").default);
Vue.component("salepage-body-cart-component", require("./Cart.vue").default);